import SplitType from 'split-type'
import { WrapLines, debounce } from './utilities'

export const splitText = () => {
	const split = new SplitType('[data-split]', { types: 'words' })
	const splitLines = new SplitType('[data-lines]', { types: 'lines' })
	const splitLinesInner = new SplitType('[data-lines-inner] p', { types: 'lines' })
	const splitChars = new SplitType('[data-chars]', { types: 'words, chars' })

	WrapLines(splitLines.lines, 'div', 'line-mask')
	WrapLines(splitLinesInner.lines, 'div', 'line-mask')

	let windowWidth = window.innerWidth

	const handleResize = () => {
		if (windowWidth != window.innerWidth) {
			split.revert()
			splitLines.revert()
			splitChars.revert()
			splitLinesInner.revert()
			windowWidth = window.innerWidth
		}
	}

	const debouncedResize = debounce(handleResize, 300)
	window.addEventListener('resize', debouncedResize)
}

export default () => {}